import React from "react";
import { INGRID_HOME_SITE } from "~/constants";
import styles from "./IngridLogo.module.scss";
import classnames from "classnames";
import { showIngridLogo } from "~/cores/brandDataCore";
import { CustomImageNew } from "rylak-common/src/image/CustomImage.jsx";

export default function IngridLogo() {
    return (
        <div className={styles["logo-wrapper"]}>
            <div
                className={styles["clickable-part"]}
                onClick={() => {
                    window.open(INGRID_HOME_SITE, { target: "_blank" });
                }}
            >
                <CustomImageNew className={styles["logo"]} fixedWidth={38} fixedHeight={14} src={"/icons/ingrid/logo-ingrid-black.svg"} />
            </div>
            {/*<div style={{ marginRight: "7px", fontSize: "11px" }}>*/}
            {/*    by Ingrid*/}
            {/*</div>*/}
        </div>
    );
}

export function IngridLogoFooter(props) {
    const { appProps } = props;
    return showIngridLogo(appProps) ? (
        <div className={classnames(styles["powered-by-turnr-wrapper"])}>
            <IngridLogo />
        </div>
    ) : null;
}
